
export default {
    methods: {
        updateFeedbackIcons () {
            const shadowRoot = this.$refs.chatbot.shadowRoot
            const positiveIcon = shadowRoot.getElementById(`positive_${this.feedbackId}`)
            const negativeIcon = shadowRoot.getElementById(`negative_${this.feedbackId}`)
            if (positiveIcon && negativeIcon) {
                if (this.feedbackType === 'positive') {
                    const copiedPositiveIcon = positiveIcon.cloneNode(true)
                    copiedPositiveIcon.classList.add('feedback-icon-sent', 'fade-in')
                    copiedPositiveIcon.classList.remove('feedback-icon')
                    copiedPositiveIcon.style.cssText = `
                        background: #EFAD66;
                        opacity: 0;
                        transition: opacity 0.5s ease-in-out;
                        margin: 10px 0px 0px;
                        padding: 8px 12px;
                        border-radius: 5px;
                    `
                    negativeIcon.remove()
                    positiveIcon.remove()
                    const parentContainer = shadowRoot.getElementById(`feedback-container_${this.feedbackId}`)
                    parentContainer.appendChild(copiedPositiveIcon)
                    let updatedshadowRoot = this.$refs.chatbot.shadowRoot
                    const element = updatedshadowRoot.getElementById(`positive_${this.feedbackId}`)
                    setTimeout(async () => {
                        element.style.opacity = 1
                    }, 500)
                }
                if (this.feedbackType === 'negative') {
                    const copiedNegativeIcon = negativeIcon.cloneNode(true)
                    copiedNegativeIcon.classList.add('feedback-icon-sent', 'fade-in')
                    copiedNegativeIcon.classList.remove('feedback-icon')
                    copiedNegativeIcon.style.cssText = `
                        background: #EFAD66;
                        opacity: 0; /* Set initial opacity to 0 for the fade-in effect */
                        transition: opacity 0.5s ease-in-out; /* Include transition property */
                        margin: 10px 0px 0px;
                        padding: 8px 12px;
                        border-radius: 5px;
                    `
                    positiveIcon.remove()
                    negativeIcon.remove()
                    const parentContainer = shadowRoot.getElementById(`feedback-container_${this.feedbackId}`)
                    parentContainer.appendChild(copiedNegativeIcon)
                    let updatedshadowRoot = this.$refs.chatbot.shadowRoot
                    const element = updatedshadowRoot.getElementById(`negative_${this.feedbackId}`)
                    setTimeout(async () => {
                        element.style.opacity = 1
                    }, 500)
                }
            }
            this.resetFeedbackElement()
        },
        resetFeedbackElement () {
            this.currentFeedbackElement = null
            this.feedbackId = null
            this.feedbackType = ''
        },
        async setFeedBackType (type) {
            await this.$store.dispatch('ChatBot/showFeedBackPanel', true)
            this.feedbackType = type
        },
        handleFeedbackClick (event) {
            const feedbackElement = event.target
            const feedbackType = feedbackElement.classList.contains('positive') ? 'positive' : 'negative'
            this.feedbackId = feedbackElement.id.split('_')[1]
            this.currentFeedbackElement = feedbackElement
            this.setFeedBackType(feedbackType)
        }
    },
    computed: {
        getFeedBackText () {
            return this.$t('Chatbot.feedback_text')
        }
    }
}
